import { render, staticRenderFns } from "./call-recordings-table.vue?vue&type=template&id=2c029360&scoped=true&"
import script from "./call-recordings-table.vue?vue&type=script&lang=js&"
export * from "./call-recordings-table.vue?vue&type=script&lang=js&"
import style0 from "./call-recordings-table.vue?vue&type=style&index=0&id=2c029360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c029360",
  null
  
)

export default component.exports